import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      main: "#01054C",
      dark: "#1C2B58",
    },
    // Usado em stepper...
    concluido: {
      100: "#9ACA3C",
      200: "#9ACA3C",
      300: "#9ACA3C",
      400: "#9ACA3C",
      500: "#9ACA3C",
      600: "#9ACA3C",
      700: "#9ACA3C",
      800: "#9ACA3C",
      900: "#9ACA3C",
    },
    recusado: {
      100: "#FF2E00",
      200: "#FF2E00",
      300: "#FF2E00",
      400: "#FF2E00",
      500: "#FF2E00",
      600: "#FF2E00",
      700: "#FF2E00",
      800: "#FF2E00",
      900: "#FF2E00",
    },
    pendente: {
      100: "#FF2E00",
      200: "#FF2E00",
      300: "#FF2E00",
      400: "#FF2E00",
      500: "#FF2E00",
      600: "#FF2E00",
      700: "#FF2E00",
      800: "#FF2E00",
      900: "#FF2E00",
    },
  },
  styles: {
    global: {
      body: {
        color: "#01054C",
      },
      main: {
        padding: "1rem",
        paddingTop: "0rem",
        backgroundColor: "#F2F2F2",
      },
    },
  },
});

export default theme;
